import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#005758', // Teal
    },
    secondary: {
      main: '#08BED5', // Aqua
    },
    background: {
      default: '#f4f6f8',
      paper: '#ffffff',
    },
    text: {
      primary: '#000000',
      secondary: '#63666A', // Cool Gray 10
    },
    error: {
      main: '#AB584D', // Copper
    },
    warning: {
        main: '#CCD814', // Chartreuse
    },
    info: {
        main: '#1F728B', // Steel Blue
    },
    success: {
        main: '#2D9F88', // Green
    }
  },
  shape: {
    borderRadius: 2, // Base border radius (2px if using 1 unit? No, MUI default is 4px. We want minor=2px. Using 2px base?) 
    // Wait, shape.borderRadius is a number. Default 4. 
    // If I want theme.spacing(1) to be 2px? No, spacing is distinct.
    // If I want `borderRadius: 1` to be 2px, I should set `shape.borderRadius: 2`.
  },
  typography: {
    fontFamily: '"Roboto", "Arial", "Helvetica", sans-serif',
    h1: {
      fontFamily: '"Roboto", "Arial", sans-serif',
      fontWeight: 700,
      fontSize: '42px',
      color: '#003031' // Deep Teal
    },
    h2: {
        fontFamily: '"Roboto", "Arial", sans-serif',
        fontWeight: 700,
        fontSize: '36px',
        color: '#003031'
    },
    h3: {
        fontFamily: '"Roboto", "Arial", sans-serif',
        fontWeight: 700,
        fontSize: '32px',
    },
    h4: {
        fontFamily: '"Roboto", "Arial", sans-serif',
        fontWeight: 600,
        fontSize: '28px',
    },
    h5: {
        fontFamily: '"Roboto", "Arial", sans-serif',
        fontWeight: 600,
        fontSize: '24px',
    },
    h6: {
        fontFamily: '"Roboto", "Arial", sans-serif',
        fontWeight: 600,
        fontSize: '20px',
    },
    body1: { // Large Text
      fontFamily: '"Roboto", "Arial", sans-serif',
      fontSize: '16px',
      lineHeight: 1.6
    },
    body2: { // Regular Text
        fontFamily: '"Roboto", "Arial", sans-serif',
        fontSize: '14px',
    },
    caption: { // Labels/Tags
        fontFamily: '"Roboto", "Arial", sans-serif',
        fontSize: '12px'
    },
    overline: { // Labels/Tags
        fontFamily: '"Roboto", "Arial", sans-serif',
        fontSize: '12px'
    },
    button: {
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '14px'
    }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 4px -1px rgba(0,0,0,0.06)',
          color: '#000000',
          borderRadius: '0px',
        },
      },
    },
    MuiDrawer: {
        styleOverrides: {
            paper: {
                background: 'radial-gradient(circle at top left, #2D9F88 0%, #003031 25%)',
                color: '#ffffff',
                borderRadius: '0px',
            }
        }
    },
    MuiButton: {
        styleOverrides: {
            root: {
                borderRadius: '2px', // Minor container
            },
            containedPrimary: {
                color: '#ffffff',
            }
        }
    },
    MuiPaper: {
        styleOverrides: {
            root: {
                borderRadius: '10px', // Major container
                boxShadow: '0 4px 12px 0 rgba(0,0,0,0.05)',
            }
        }
    },
    MuiCard: {
        styleOverrides: {
            root: {
                borderRadius: '10px', // Major container
                boxShadow: '0 4px 12px 0 rgba(0,0,0,0.05)',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                    transform: 'scale(1.02)'
                }
            }
        }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '2px', // Minor container
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '10px', // Major container
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '2px', // Minor container
        }
      }
    }
  },
});
